export default "__VITE_ASSET__P4ekixwM__"